module.exports = __webpack_public_path__ + "img/left_bg.34796172.png";